/** Дублирует группы backend PERMISSION_UI_CATALOG (страница «Роли» legacy). */

export const PERMISSION_UI_CATALOG = [
  {
    moduleKey: 'applications',
    title: 'Заявки',
    permissions: [
      { key: 'applications.view', label: 'Просмотр заявок' },
      { key: 'applications.create', label: 'Создание заявок' },
      { key: 'applications.edit', label: 'Изменение заявок' },
      { key: 'applications.view_own', label: 'Просмотр только своих заявок (клиент)' }
    ]
  },
  {
    moduleKey: 'routes',
    title: 'Маршруты',
    permissions: [
      { key: 'routes.view', label: 'Просмотр маршрутов' },
      { key: 'routes.create', label: 'Создание маршрутов' },
      { key: 'routes.edit', label: 'Изменение маршрутов' },
      { key: 'routes.update_location', label: 'Обновление местоположения (водитель)' },
      {
        key: 'routes.finance_view',
        label: 'Финансовые показатели в маршруте (без доступа к модулю «Финансы»)'
      }
    ]
  },
  {
    moduleKey: 'finance',
    title: 'Финансы',
    permissions: [
      { key: 'finance.view', label: 'Просмотр финансового модуля' },
      { key: 'finance.edit', label: 'Операции в финансах (платежи, счета, …)' },
      { key: 'finance.invoice_send', label: 'Отправка счёта клиенту по задаче (без полного finance.edit)' }
    ]
  },
  {
    moduleKey: 'documents',
    title: 'Документы',
    permissions: [
      { key: 'documents.view', label: 'Доступ к разделу документов (меню)' },
      { key: 'documents.upload', label: 'Загрузка документов' },
      { key: 'documents.edit', label: 'Редактирование комплекта закрывающих документов' },
      { key: 'documents.dispatch', label: 'Отправка сканов / регистрация согласования и получения' }
    ]
  },
  {
    moduleKey: 'tasks',
    title: 'Задачи и контроль',
    permissions: [
      { key: 'tasks.view', label: 'Просмотр задач контроля' },
      { key: 'tasks.edit', label: 'Закрытие и отмена задач контроля' }
    ]
  },
  {
    moduleKey: 'references',
    title: 'Справочники',
    permissions: [
      { key: 'references.view', label: 'Просмотр справочников' },
      { key: 'references.create', label: 'Создание записей' },
      { key: 'references.edit', label: 'Изменение записей' }
    ]
  },
  {
    moduleKey: 'other',
    title: 'Прочее',
    permissions: [
      { key: 'analytics.view', label: 'Аналитика' },
      { key: 'reports.view', label: 'Отчёты' },
      { key: 'warehouse.view', label: 'Склад: просмотр' },
      { key: 'warehouse.move', label: 'Склад: перемещения' },
      { key: 'cargo.allocate', label: 'Распределение грузов по маршрутам' }
    ]
  }
] as const;

export const PERMISSION_GROUPS = PERMISSION_UI_CATALOG.map((g) => ({
  title: g.title,
  permissions: g.permissions.map((p) => ({ key: p.key, label: p.label }))
}));

export const ALL_PERMISSIONS = PERMISSION_GROUPS.flatMap((g) => g.permissions);
